import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
const privacyContent = {
  title: 'Política de Privacidad',
  sections: [{
    heading: '1. Información que Recopilamos',
    text: 'Recopilamos información personal que nos proporcionas voluntariamente al realizar una compra, como tu nombre, dirección de correo electrónico y datos de pago. No recopilamos información sensible adicional más allá de lo necesario para procesar tu pedido.'
  }, {
    heading: '2. Uso de la Información',
    text: 'Utilizamos tu información personal exclusivamente para: procesar y entregar tu compra del Perfil Trino Express, enviarte comunicaciones relacionadas con tu pedido, y mejorar nuestros productos y servicios. No vendemos, alquilamos ni compartimos tu información personal con terceros para fines de marketing.'
  }, {
    heading: '3. Protección de Datos',
    text: 'Implementamos medidas de seguridad técnicas y organizativas para proteger tu información personal contra acceso no autorizado, alteración, divulgación o destrucción. Todos los pagos se procesan a través de plataformas seguras con encriptación SSL.'
  }, {
    heading: '4. Cookies',
    text: 'Nuestro sitio web puede utilizar cookies para mejorar tu experiencia de navegación. Puedes configurar tu navegador para rechazar cookies, aunque esto podría afectar algunas funcionalidades del sitio.'
  }, {
    heading: '5. Tus Derechos',
    text: 'Tienes derecho a acceder, rectificar o eliminar tu información personal en cualquier momento. Para ejercer estos derechos, puedes contactarnos a través de los canales disponibles en nuestro sitio web.'
  }, {
    heading: '6. Cambios en esta Política',
    text: 'Nos reservamos el derecho de actualizar esta política de privacidad en cualquier momento. Los cambios serán publicados en esta página con la fecha de última actualización.'
  }]
};
const termsContent = {
  title: 'Términos y Condiciones',
  sections: [{
    heading: '1. Aceptación de los Términos',
    text: 'Al acceder y utilizar este sitio web y adquirir el Perfil Trino Express, aceptas estar sujeto a estos términos y condiciones. Si no estás de acuerdo con alguno de estos términos, te recomendamos no utilizar nuestros servicios.'
  }, {
    heading: '2. Descripción del Producto',
    text: 'El Perfil Trino Express es una guía digital de autodescubrimiento en formato PDF que integra conceptos de Numerología, Tzolkin Maya y Astrología. Es una herramienta educativa y de desarrollo personal, no constituye asesoramiento profesional médico, psicológico ni financiero.'
  }, {
    heading: '3. Entrega del Producto',
    text: 'El Perfil Trino Express se entrega en formato digital (PDF) mediante descarga inmediata tras la confirmación del pago. El acceso es de por vida una vez completada la compra.'
  }, {
    heading: '4. Política de Reembolso',
    text: 'Debido a la naturaleza digital del producto y su entrega inmediata, no se ofrecen reembolsos una vez completada la descarga. Si experimentas problemas técnicos con la descarga, nos comprometemos a resolver el inconveniente.'
  }, {
    heading: '5. Propiedad Intelectual',
    text: 'Todo el contenido del Perfil Trino Express, incluyendo textos, gráficos, plantillas y metodologías, está protegido por derechos de autor. Queda prohibida su reproducción, distribución o reventa sin autorización expresa por escrito.'
  }, {
    heading: '6. Uso Personal',
    text: 'El producto adquirido es para uso personal exclusivo del comprador. No está permitido compartir, redistribuir o utilizar el contenido con fines comerciales sin autorización previa.'
  }, {
    heading: '7. Limitación de Responsabilidad',
    text: 'Los resultados obtenidos con el Perfil Trino Express pueden variar según cada persona. No garantizamos resultados específicos. El usuario es responsable de la aplicación e interpretación del contenido proporcionado.'
  }, {
    heading: '8. Modificaciones',
    text: 'Nos reservamos el derecho de modificar estos términos y condiciones en cualquier momento. Las modificaciones entrarán en vigor desde su publicación en el sitio web.'
  }]
};
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const content = activeModal === 'privacy' ? privacyContent : activeModal === 'terms' ? termsContent : null;
  return <>
      <footer className="bg-trino-dark text-trino-cream/50 py-10 text-sm" data-id="element-35">
        <div className="max-w-7xl mx-auto px-4 flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-36">
          <p data-id="element-37">
            © {new Date().getFullYear()} Perfil Trino Express. Todos los
            derechos reservados.
          </p>
          <div className="flex items-center gap-6" data-id="element-38">
            <button onClick={() => setActiveModal('privacy')} className="text-trino-cream/50 hover:text-trino-gold transition-colors duration-200 underline underline-offset-2 decoration-trino-cream/20 hover:decoration-trino-gold" data-id="element-39">
              Política de Privacidad
            </button>
            <span className="text-trino-cream/20" data-id="element-40">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-trino-cream/50 hover:text-trino-gold transition-colors duration-200 underline underline-offset-2 decoration-trino-cream/20 hover:decoration-trino-gold" data-id="element-41">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      {/* Modal / Popup */}
      <AnimatePresence data-id="element-42">
        {activeModal && content && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.25
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-43">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.3,
          ease: 'easeOut'
        }} onClick={e => e.stopPropagation()} className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[85vh] flex flex-col overflow-hidden border border-trino-peach/30" data-id="element-44">
              {/* Header */}
              <div className="flex items-center justify-between px-8 py-5 border-b border-trino-peach/30 bg-trino-cream/50 flex-shrink-0" data-id="element-45">
                <h2 className="text-2xl font-serif font-bold text-trino-burgundy" data-id="element-46">
                  {content.title}
                </h2>
                <button onClick={() => setActiveModal(null)} className="p-2 rounded-full hover:bg-trino-peach/30 transition-colors text-trino-dark/60 hover:text-trino-burgundy" aria-label="Cerrar" data-id="element-47">
                  <XIcon className="w-5 h-5" data-id="element-48" />
                </button>
              </div>

              {/* Body */}
              <div className="overflow-y-auto px-8 py-6 space-y-6 flex-1" data-id="element-49">
                {content.sections.map((section, index) => <div key={index} data-id="element-50">
                    <h3 className="text-lg font-bold text-trino-dark mb-2 font-serif" data-id="element-51">
                      {section.heading}
                    </h3>
                    <p className="text-trino-dark/70 leading-relaxed" data-id="element-52">
                      {section.text}
                    </p>
                  </div>)}
                <p className="text-trino-dark/40 text-xs pt-4 border-t border-trino-peach/20" data-id="element-53">
                  Última actualización: Abril 2026
                </p>
              </div>

              {/* Footer */}
              <div className="px-8 py-4 border-t border-trino-peach/30 bg-trino-cream/30 flex-shrink-0" data-id="element-54">
                <button onClick={() => setActiveModal(null)} className="w-full sm:w-auto bg-trino-burgundy text-white font-semibold px-6 py-2.5 rounded-lg hover:bg-trino-burgundy/90 transition-colors" data-id="element-55">
                  Cerrar
                </button>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}